import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTheme, applyTitle, resolveFromCache } from './themes';
import './styles/global.css';

/**
 * Ap giao dien TRUOC khi React ve lan dau.
 *
 * Dung thuong hieu DA NHO cua dung ten mien nay, khong goi mang: cho cau tra loi cua
 * may chu thi mot giao dien nen SANG se nhay qua nen toi mac dinh truoc, va cu nhay do
 * la thu dau tien nguoi choi thay khi mo website.
 *
 * `ThemeProvider` sau do hoi `GET /v1/brand` - nguon su that - va ap lai neu khac. Lan
 * dau vao mot ten mien chua nho thi buoc nay ra mac dinh; tu lan sau thi da dung ngay.
 */
const doan = resolveFromCache(window.location);
applyTheme(doan.theme);
applyTitle(doan.theme, doan.brand);

const container = document.getElementById('root');
if (!container) throw new Error('Khong tim thay phan tu goc #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
